import PropTypes from "prop-types";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import SvgIcon from "../../../../parts/SvgIcon";

const COPIED_MS = 2000;

const CopyValueButton = ({ value }) => {
  const { t } = useTranslation("coaching-portal");
  const [copied, setCopied] = useState(false);

  const copy = async () => {
    await navigator.clipboard.writeText(value);
    setCopied(true);
    setTimeout(() => setCopied(false), COPIED_MS);
  };

  return (
    <button
      type="button"
      className="es-copy"
      onClick={copy}
      aria-label={t(`emailSending.records.${copied ? "copied" : "copy"}`)}
      title={t(`emailSending.records.${copied ? "copied" : "copy"}`)}
    >
      <SvgIcon src={`/img/new-icons/${copied ? "check" : "copy-grey"}.svg`} />
    </button>
  );
};

CopyValueButton.propTypes = { value: PropTypes.string.isRequired };

export default CopyValueButton;
